import { t } from "@lingui/macro";

import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

import { PublicClubSearchResult } from "../hooks/usePublicClubsSearch";
import { ClubSelectionResultItem } from "./ClubSelectionResultItem";

export const ClubSelectionResults = ({
  results,
  searchString,
  emailOrPhone,
}: {
  results: PublicClubSearchResult[];
  searchString: string;
  emailOrPhone: string | null;
}) => {
  return (
    <VStack gap={2}>
      {results.length > 0 ? (
        results.map((result) => (
          <ClubSelectionResultItem
            key={result.id}
            result={result}
            emailOrPhone={emailOrPhone}
          />
        ))
      ) : searchString.length > 0 ? (
        <Text
          variant={"mainBaseMedium"}
          color="text-secondary"
          textAlign="center"
        >
          {t`No public facilities matching "${searchString}" found`}
        </Text>
      ) : null}
    </VStack>
  );
};
